module.exports = __webpack_public_path__ + "images/fdbe134a88e7a690f5a1965d0140b28c.png";